import { USER_DETAILS_CLEAR, USER_DETAILS_FAIL, USER_DETAILS_REQUEST, USER_DETAILS_SUCCESS, USER_LIST_FAIL, USER_LIST_REQUEST, USER_LIST_SUCCESS, USER_UPDATE_FAIL, USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS } from "../constants/userConstants";

export const userListReducer = (
    state = {
        users: []
    },
    action
) => {
    switch (action.type) {

        case USER_LIST_REQUEST:
            return {
                loading: true,
                users: []
            };

        case USER_LIST_SUCCESS:
            return {
                loading: false,
                users: action.payload
            };
            
        case USER_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
            
        default:
            return state;    
    }
};

export const userDetailsReducer = (
    state = {
        user: null
    },
    action
) => {
    switch (action.type) {

        case USER_DETAILS_REQUEST:
            return {
                loading: true,
            };

        case USER_DETAILS_SUCCESS:
            return {
                loading: false,
                user: action.payload
            };
            
        case USER_DETAILS_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        case USER_DETAILS_CLEAR:
            return {
                user: null
            };    
            
        default:
            return state;    
    }        
}

export const userUpdateReducer = (
    state = {},
    action
) => {
    switch (action.type) {
        case USER_UPDATE_REQUEST:
            return { loading: true };

        case USER_UPDATE_SUCCESS:
            return {
                loading: false,
                success: true
            };
        
        case USER_UPDATE_FAIL:
            return {
                loading: false,
                error: action.payload
            };

        default:
            return state;    
    }
}